import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const MyRecord = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { recordList = [], channelType = "", title = "", tab, from } = location.state || {};

    console.log(tab)

    // 채널 기준으로 이미지 필터링
    const filteredRecords = (recordList || []).filter((item) => {
        if (!item || typeof item.channel !== "number") return false;

        switch (channelType) {
            case "instagram":
                return item.channel === 2 || item.channel === 3;
            case "kakao":
                return item.channel === 1;
            case "blog":
                return item.channel === 4;
            case "band":
                return item.channel === 6;
            default:
                return false;
        }
    });

    // 채널 필터 후 최신순 정렬
    const sortedRecords = [...(filteredRecords || [])].sort((a, b) => {
        const ta = new Date(a?.start_date || 0).getTime();
        const tb = new Date(b?.start_date || 0).getTime();
        return tb - ta; // 최근(큰 값) 먼저
    });

    const goMypage = () => {
        if (tab === "mypage" && from === "direct") {
            navigate("/ads/main", { state: { tab: "mypage" } })
        }
        else {
            navigate(-1)
        };
    };

    return (
        <div className="h-dvh bg-white px-4 pt-6">
            {/* 헤더 */}
            <div className="flex items-center space-x-2 pb-4">
                <button onClick={goMypage}>
                    <FiArrowLeft className="text-xl text-black" />
                </button>
                <h1 className="text-xl font-bold">{title}</h1>
            </div>

            {/* 통계 (예시로 더미 데이터) */}
            {/* <div className="flex justify-around text-center text-sm text-gray-500 py-4 border-b">
                <div>
                    <p className="text-lg font-bold text-black">2.3K</p>
                    좋아요
                </div>
                <div>
                    <p className="text-lg font-bold text-black">{filteredRecords.length}</p>
                    포스팅 수
                </div>
                <div>
                    <p className="text-lg font-bold text-black">736</p>
                    팔로잉
                </div>
                <div>
                    <p className="text-lg font-bold text-black">12</p>
                    조회수
                </div>
                <div>
                    <p className="text-lg font-bold  text-red-500">14%</p>
                    참여율
                </div>
            </div> */}

            {/* 이미지 그리드 */}
            <div className="grid grid-cols-3 pt-4">
                {sortedRecords.map((item, index) => (
                    <div
                        key={index}
                        className="relative w-full aspect-square overflow-hidden"
                    >
                        <img
                            src={item.image_path}
                            alt={`record-${index}`}
                            className="w-full h-full object-cover"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyRecord;
